import React from 'react';
import { BookOpen, Sparkles, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function TopBanner() {
  return <div className="sticky top-0 z-50 bg-beige-200 text-navy-900 py-2 md:py-3 px-3 md:px-4 shadow-md border-b border-gold-500/20" data-id="element-578">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-2 md:gap-3" data-id="element-579">
        <div className="flex items-center gap-2 text-xs sm:text-sm md:text-base font-medium text-center sm:text-left" data-id="element-580">
          <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-red-600 flex-shrink-0 animate-pulse" data-id="element-581" />
          <span className="leading-tight" data-id="element-582">
            <span className="text-red-600 font-bold" data-id="element-583">
              ⏰ OFERTA POR TIEMPO LIMITADO:
            </span>{' '}
            Aprovecha Esta Super Oferta Especial Por Promoción De Lanzamiento!!!
          </span>
        </div>

        <Button variant="primary" size="sm" className="bg-navy-800 hover:bg-navy-900 text-white border-none shadow-none text-xs sm:text-sm py-1.5 px-3 sm:px-4 h-auto whitespace-nowrap flex-shrink-0" data-id="element-584">
          <Sparkles className="w-3 h-3 mr-1 sm:mr-2" data-id="element-585" />
          Edición Premium
        </Button>
      </div>
    </div>;
}